import {Tooltip} from "react-tooltip";
import {IconWrapper} from "./styles";

// interface Iprops {
//     tooltipId, tooltipContent, volume, investVolume, trl, activeIcon, inactiveIcon
// }

const IconsParams: React.FC<any> = ({
  tooltipId,
  tooltipContent,
  volume,
  investVolume,
  trl,
  activeIcon,
  inactiveIcon,
}) => {
  return (
    <div style={{display: "flex", gap: 3}}>
      {[0, 1, 2].map((level) => (
        <IconWrapper
          key={level}
          data-tooltip-id={tooltipId}
          data-tooltip-content={tooltipContent}
          data-tooltip-place="top"
          // disabled={isInvestVolume}
        >
          <img
            src={level < volume ? activeIcon : inactiveIcon}
            width="100%"
            height="100%"
            alt={"alt"}
          />
        </IconWrapper>
      ))}
      {/* <Tooltip
        id={
          volume === investVolume || volume === trl
            ? "investmentTooltip"
            : "marketTooltip"
        }
        // id="investmentTooltip"
        className="tooltip"
        noArrow
        offset={4}
      />
      <Tooltip id="marketTooltip" className="tooltip" noArrow offset={4} /> */}
    </div>
  );
};

export default IconsParams;
